import $ from 'jquery';

// Wait for form to load before checking
window.addEventListener('message', event => {
  if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
    if($('input[name="email_globally_unsubscribe"]').prop('checked')){
      uncheck('email_globally_unsubscribe'); 
    } else if ($('input[name="global_email_subscription"]').prop('checked')){
      uncheck('global_email_subscription');
    }
    
    $(document).on('change', 'input[name="email_globally_unsubscribe"]', function() {
      uncheck('email_globally_unsubscribe');
    });

    $(document).on('change', 'input[name="global_email_subscription"]', function() {
      uncheck('global_email_subscription');
    });
  }
});

function uncheck(selector) {
  if($('input[name="' + selector + '"]').prop('checked')){
    $('input[type="checkbox"]:not(input[name="' + selector + '"])').attr('disabled', true);
    $('.hs-fieldtype-booleancheckbox:not(.hs-' + selector + ')').css('opacity', 0.6);
  } else {
    $('input[type="checkbox"]:not(input[name="' + selector + '"])').attr('disabled', false);
    $('.hs-fieldtype-booleancheckbox:not(.hs-' + selector + ')').css('opacity', 1.0);
  }
}
